import React, { useEffect, useState } from "react";
import "../../assets/styles/auth/login.scss";
import google from "../../assets/svg/icon-google.svg";
import iconLoading from "../../assets/svg/icon-loading.svg";
import mainLogo from "../../assets/svg/logo_main.svg";
import loginBackground from "../../assets/svg/login_background.png";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import NewInput from "../../components/simple/NewInput";
import QuestionAuth from "../../assets/svg/question-auth.svg";
import DemoIconAuth from "../../assets/svg/demo-icon.svg";
import { apiDemoUser, apiLogin, apiSetAlert } from "../../api/appApi";
import { useDispatch, useSelector } from "react-redux";
import { formatMobile, validateMobile } from "../../helpers";
import Lottie from "../../components/public/Lottie";
import { StyledReCAPTCHA } from "./components";
import Captcha from "./Captcha";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { Grid } from "@mui/material";
import { apiGetNews } from "../../api/newsApi";
import { icons } from "lucide-react";
import { Helmet } from 'react-helmet'
import { dicHasval } from "helpers/helper";

export default function Login({ demo }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);
  const token = useSelector((state) => state.appReducer.token);
  const news = useSelector((state) => state.newsReducer.news);
  const [queryParams, setQueryParams] = useState({});
  const [demoLogin, setDemoLogin] = useState(demo || false);
  const [reCaptcha, setReCaptcha] = useState(false);
  const [inputFields, setInputFields] = useState({
    ePhone: "",
    password: "",
    userMobile: ""
  });

  useEffect(() => {
    // Function to extract query parameters and convert them to an object
    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      const paramsObj = {};
      for (let [key, value] of params.entries()) {
        paramsObj[key] = value;
      }
      return paramsObj;
    };
    // Set the query parameters in the state
    const paramsObj = getQueryParams();
    if (dicHasval(paramsObj)) {
      localStorage.setItem("query_Params", JSON.stringify(paramsObj))
    }
    setQueryParams(paramsObj);
  }, []);

  useEffect(() => {
    dispatch(apiGetNews());
  }, []);

  useEffect(() => {
    if (token) navigate("/");
  }, [token]);

  useEffect(() => {
    if (demoLogin) {
      navigate("/auth/demo");
      setInputFields({
        ePhone: "demo@chortke.app",
        password: "demo",
        userMobile: ""
      });
    } else {
      navigate("/auth/login");
      setInputFields({
        ePhone: "",
        password: "",
        userMobile: ""
      });
    }
  }, [demoLogin]);

  function goToRegister(e) {
    navigate("/auth/register");
    e.preventDefault();
  }

  function goToForgetPassword(e) {
    navigate("/auth/forgotPassword");
    e.preventDefault();
  }

  function login() {
    if (!reCaptcha) {
      dispatch(apiSetAlert("لطفا راستی آزمایی را تکمیل نمایید", "warning"));
    } else if (demoLogin) {
      if (validateMobile(inputFields.userMobile)) {
        dispatch(apiDemoUser(inputFields, queryParams));
      } else {
        dispatch(apiSetAlert("شماره موبایل صحیح نمی باشد", "warning"));
      }
    } else {
      dispatch(apiLogin(inputFields, null, null, queryParams));
    }
  }

  return (
    <>
      <Helmet>
        <html lang="fa-IR" />
        <title>ورود به حساب کاربری نرم افزار حسابداری چرتکه</title>
        <meta name="description" content="جهت ورود به پنل نرم افزار حسابداری ابری چرتکه کلیک کنید" />
      </Helmet>
      <div className="min-h-lvh background-image py-12 px-6 flex flex-col justify-center items-center">
        <div className="flex flex-col items-center justify-center w-fit">
          <div className=" flex items-start justify-center lg:justify-start px-8 w-full">
            <img src={mainLogo} alt="logo" />
          </div>
          <div
            className="flex flex-col lg:flex-row gap-12 items-center align-items-center ">
            <div className="flex-shrink-0">
              <div className="flex flex-column">
                <div className="wrap-login-parent">
                  <div className="wrap-login">
                    <form>
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <h5>ورود به چرتکه</h5>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 d-flex justify-content-around">
                          <div className="login-version-demo" onClick={() => setDemoLogin((x) => !x)}>
                            <img src={DemoIconAuth} alt="" />
                            {demoLogin ? <b>ورود به پنل حسابداری</b> : <b>ورود به نسخه دمو</b>}
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-login-in-register">
                          کاربر جدید هستید ؟ <b onClick={goToRegister}>از اینجا ثبت نام کنید </b>
                        </div>
                        {!demoLogin ? (
                          <div className="flex flex-col gap-6 mt-6">
                            <form className="flex flex-col gap-6">
                              <BasicTextInput
                                label="نام کاربری"
                                placeHolder="ایمیل یا شماره موبایل خود را وارد نمایید"
                                type="email"
                                val={inputFields.value}
                                autoComplete="on"
                                onChange={(val) =>
                                  setInputFields((prev) => {
                                    return {
                                      ePhone: val,
                                      password: prev.password
                                    };
                                  })
                                }
                              />
                              <BasicTextInput
                                label="کلمه عبور"
                                placeHolder="کلمه عبور خود را وارد نمایید"
                                type="password"
                                val={inputFields.password}
                                autoComplete="on"
                                onChange={(val) =>
                                  setInputFields((prev) => {
                                    return {
                                      ePhone: prev.ePhone,
                                      password: val
                                    };
                                  })
                                }
                              />
                            </form>

                            <div className="py-4">
                              <Captcha validate={(res) => setReCaptcha(res)} submit={login} />
                            </div>
                          </div>
                        ) : null}
                        {demoLogin ? (
                          <div className="flex flex-col gap-6 mt-6">
                            <form>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <NewInput
                                  placeholder={"جهت ورود به نسخه دمو، لطفا تلفن همراه خود را وارد نمایید"}
                                  label={"تلفن همراه"}
                                  type={"text"}
                                  onChange={(e) =>
                                    setInputFields((prev) => {
                                      return {
                                        ePhone: prev.ePhone,
                                        password: prev.password,
                                        userMobile: formatMobile(e.target.value),
                                        phone: formatMobile(e.target.value)
                                      };
                                    })
                                  }
                                  value={inputFields.userMobile}
                                />
                              </div>
                            </form>
                            <div className="mb-6">
                              <Captcha validate={(res) => setReCaptcha(res)} submit={login} />
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                        {/* <div className="p-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 recaptch-login">
              <StyledReCAPTCHA
                sitekey="6Ld6C7IcAAAAAKO3b-DCLe56b0yEQ7LM1Rjuh_-B"
                hl={"fa"}
                onChange={() => setReCaptcha(true)}
              />
            </div> */}
                        {/* <div className="btns col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div className="btn-google">
                <img src={google} alt="google" />
                ورود با گوگل
              </div>
            </div> */}

                        <div className="flex items-center gap-6">
                          {!demoLogin && (
                            <BasicButton onClick={goToForgetPassword} variant="outlined" className="w-full">
                              <span className="text-sm font-bold text-blue-1">فراموشی رمز عبور</span>
                            </BasicButton>
                          )}
                          <BasicButton
                            variant="contained"
                            disabled={sendingRequest}
                            onClick={() => login()}
                            className="w-full"
                          >
                            {sendingRequest ? <img src={iconLoading} alt="loading" /> : "ورود"}
                          </BasicButton>
                        </div>
                        {/* {!demoLogin && (
            <div className="mt-2 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-login-in-register d-flex">
              <img style={{ width: "10px" }} src={QuestionAuth} alt="QuestionAuth" />
              <b onClick={goToForgetPassword}>کلمه عبور خود را فراموش کرده اید ؟</b>
            </div>
          )} */}
                      </div>
                      {/*<div className="desktop-info">*/}
                      {/*  <div>*/}
                      {/*    <img src={IconDesktopAuth} alt="IconDesktopAuth" />*/}
                      {/*  </div>*/}
                      {/*  <div>*/}
                      {/*    <p>*/}
                      {/*      <a href="https://www.chortke.app/desktop/chortke-desktop%20v1.0.exe">*/}
                      {/*        برای دسترسی و استفاده آسان تر میتوانید نسخه ی ویندوز نرم افزار حسابداری چرتکه را از این لینک دانلود*/}
                      {/*        نمایید*/}
                      {/*      </a>*/}
                      {/*    </p>*/}
                      {/*  </div>*/}
                      {/*</div>*/}
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4">
              {demoLogin && (
                <div className="self-center justify-center">
                  <div
                    className="wrap-login-news self-center opacity-80 overflow-y-auto max-h-[70vh] min-h-[70vh] max-w-[70vh]">
                    <div className="mb-4"><b>حسابداری ابری چرتکه</b>
                      <div className="flex flex-col px-1 py-1 mb-3"
                        style={{ borderRadius: "10px", border: "1px solid darkgray" }}>
                        <div>
                          <div className="text-lightGray mt-[4px]  text-sm text-right ">
                            <p className="mb-1 mr-1">برای آشنایی با کارایی و محیط نرم افزار حسابداری چرتکه می توانید
                              تمام
                              قابلیت های هارا با ثبت نام در نسخه دمو کسب نمایید.</p>
                            <p className="mb-1 mr-1">با ثبت نام در نسخه دمو قادر خواهید بود:</p>
                            <ul className="mb-1 mr-1">
                              <li key={1}> • از 100% امکانات نرم افزار استفاده و گزارش های دلخواهتان را از نرم افزار
                                استخراج
                                نمایید.
                              </li>
                              <li key={2}> • نیازمندی های اساسی خود را به دقت بررسی و از سهولت دسترسی به ابزارها اطمینان
                                حاصل کنید، و با کاربرد هر یک از قابلیت های نرم افزار حسابداری چرتکه آشنا شوید.
                              </li>
                              <li key={3}>• اگر نیاز به راهنمایی داشتید مشاوران شما در چرتکه در کنارتان هستند.</li>
                            </ul>
                            <span>
                              <a
                                className="mr-2"
                                style={{ color: "#1062d0" }}
                                href="tel:+982152127"
                                target="_blank"
                                rel="noopener nofollow"
                              >
                                021-52127
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>
                      {news != null && news.map((item, index) => {
                        let LucideIcon = icons[item.icon];
                        if (!LucideIcon) LucideIcon = icons["BadgeAlert"];
                        return (
                          <div key={index} className="flex flex-col px-1 py-1 mb-3"
                            style={{ borderRadius: "10px", border: "1px solid darkgray" }}>
                            <div
                              className="flex w-full flex-row items-center justify-center"
                            >
                              <div
                                className="flex min-w-[44px] min-h-[44px] items-start justify-center self-start bg-[#E8F2FF] rounded-lg">
                                <LucideIcon color={"#1062d0"} className="items-center justify-center self-center" />
                              </div>
                              <div className="flex flex-row mr-2 w-full ">
                                <div className="flex flex-col items-start ">
                                  <span className="text-sm font-bold text-blue-1">
                                    {item.title}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div>
                              <span className="text-lightGray mt-[4px]  text-sm text-right ">
                                {
                                  item.description.split("\n").map((text, index) => {
                                    return (
                                      <p key={index} className="mb-1 mr-1">
                                        {text}
                                      </p>
                                    );
                                  })
                                }
                                {/*{item.description}*/}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
